import { Chart } from '@frontend/chart/types';

export const LENDING_OUTBOUND_PACKAGE_VOLUME_BY_PRODUCT_MONTHLY_LIST_CHART_MOCK_DATA: Chart = {
    series: [
        {
            name: 'Impact drill',
            data: [
                { label: '2026-06-01', value: 62 },
                { label: '2026-07-01', value: 86 }
            ]
        },
        {
            name: 'Torque wrench',
            data: [
                { label: '2026-06-01', value: 78 },
                { label: '2026-07-01', value: 64 }
            ]
        },
        {
            name: 'Multimeter',
            data: [
                { label: '2026-06-01', value: 36 },
                { label: '2026-07-01', value: 51 }
            ]
        },
        {
            name: 'Laser level',
            data: [
                { label: '2026-06-01', value: 48 },
                { label: '2026-07-01', value: 38 }
            ]
        },
        {
            name: 'Heat gun',
            data: [
                { label: '2026-06-01', value: 18 },
                { label: '2026-07-01', value: 27 }
            ]
        },
        {
            name: 'Cable tester',
            data: [
                { label: '2026-06-01', value: 22 },
                { label: '2026-07-01', value: 14 }
            ]
        },
        {
            name: 'Pipe cutter',
            data: [
                { label: '2026-06-01', value: 6 },
                { label: '2026-07-01', value: 9 }
            ]
        },
        {
            name: 'Inspection camera',
            data: [
                { label: '2026-06-01', value: 8 },
                { label: '2026-07-01', value: 3 }
            ]
        }
    ]
};
